<template>
  <el-dialog
    title="选择内容链接"
    :visible.sync="visible"
    width="640px"
    append-to-body
    :close-on-press-escape="false">
    <div class="content-wrap">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane
          label="门户内容"
          name="0">
          <message-info
            :linkType="0"
            :contentTypes="[0]"
            @select="select" />
        </el-tab-pane>
        <el-tab-pane
          label="解决方案"
          name="1">
          <message-info
            :linkType="0"
            :contentTypes="[100]"
            @select="select" />
        </el-tab-pane>
        <!-- <el-tab-pane
          label="积分活动"
          name="4">
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:4, link: 15, contentType: 1 , title: '步数兑换'})">
            步数兑换
          </el-tag>
        </el-tab-pane> -->
        <!-- <el-tab-pane
        label="积分活动列表"
        name="14"></el-tab-pane> -->
        <el-tab-pane
          label="其他链接"
          name="6">
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:51, link: null, title: '鉴定中心入口'})">
            鉴定中心入口
          </el-tag>
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:50, link: null, title: '鉴定考试入口'})">
            鉴定考试入口
          </el-tag>
        </el-tab-pane>
      </el-tabs>
    </div>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        关 闭
      </el-button>
      <!-- <el-button
        type="primary"
        :loading="loading"
        @click="addTemplate(-1)">自定义</el-button> -->
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import MessageInfo from './busi-content/message-info.vue'
export default {
  name: 'ContentSelectModal',
  components: { MessageInfo },
  data() {
    return {
      loading: false,
      visible: false,
      activeName: '',
      selectList: [],
      row: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  methods: {
    select(item) {
      console.log(item)
      this.$emit('handleSelect', item, this.row.$index)
      this.toggleModal(false)
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClick() {},
    init(row, $index) {
      this.row = {
        ...row,
        $index
      }
      this.toggleModal(true)
    }
  }
}
</script>
<style lang="stylus">
.content-wrap {
  .el-tabs__content {
    height: 400px;
  }

  .el-tag {
    cursor: pointer;
  }

  .el-tag+.el-tag {
    margin-left: 8px;
  }
}
</style>
